import React, { createContext, ReactNode, useState } from "react";

// Context for managing tabs
const TabsContext = createContext<{
	activeTab: string;
	setActiveTab: (title: string) => void;
} | null>(null);

interface TabsContainerProps {
	children: ReactNode;
	addiTionalHeaderComponent?: ReactNode;
	tabContainerClassName?: string;
	tabItemClassName?: string;
	tabContentContainerClassName?: string;
	containerClassName?: string;
}

export function TabsContainer({
	children,
	addiTionalHeaderComponent,
	tabContainerClassName,
	tabItemClassName,
	tabContentContainerClassName,
	containerClassName,
}: TabsContainerProps) {
	const childrenArray = React.Children.toArray(children);
	const firstChild = childrenArray[0];
	const firstTabTitle = React.isValidElement(firstChild)
		? (firstChild.props as TabProps).title
		: "";

	const [activeTab, setActiveTab] = useState<string>(firstTabTitle);

	return (
		<TabsContext.Provider value={{ activeTab, setActiveTab }}>
			<div className={`w-full ${containerClassName ?? ""}`}>
				<div className="flex justify-between items-center">
					<div className={`flex ${tabContainerClassName ?? ""}`}>
						{React.Children.map(children, (child) => {
							if (!React.isValidElement(child)) {
								return null;
							}

							const { title } = child.props as TabProps;

							return (
								<button
									key={title}
									className={`text-[14px] text-nowrap px-4 py-3 font-medium transition-all ${
										activeTab === title
											? "border-b-2 border-accent text-accent-strong"
											: "border-b-2 border-transparent text-subtle hover:text-text"
									} ${tabItemClassName ?? ""}`}
									onClick={() => setActiveTab(title)}
								>
									{title}
								</button>
							);
						})}
					</div>
					{React.isValidElement(addiTionalHeaderComponent) ? addiTionalHeaderComponent : <></>}
				</div>

				<div className={`mt-6 ${tabContentContainerClassName ?? ""}`}>
					{React.Children.map(children, (child) => {
						if (!React.isValidElement(child)) {
							return null;
						}

						const { title: tabTitle, children: tabChildren } = child.props as TabProps;

						return tabTitle === activeTab ? tabChildren : null;
					})}
				</div>
			</div>
		</TabsContext.Provider>
	);
}

interface TabProps {
	title: string;
	children: ReactNode;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars, react/prop-types
export function Tab({ title, children }: TabProps) {
	return <>{children}</>;
}
